import { combineReducers } from '@reduxjs/toolkit';
import createMemberReducer from './create/createSlice';
import memberListReducer from './list/listSlice';
import deleteMemberReducer from './delete/deleteSlice';

const membersSlice = combineReducers({
    create: createMemberReducer,
    list: memberListReducer,
    delete: deleteMemberReducer,
});

export default membersSlice;
